// @flow
import React, { useState } from 'react';
// Components
import LoginBox from './LoginBox';
import RegisterBox from './RegisterBox';
// Styles
import './Login.css';

type Props = {
  alertText: string,
  isLoggingIn: boolean,
  isRegistering: boolean,
  loginErrors: {
    badUsername: boolean,
    badPassword: boolean,
  },
  registrationErrors: {},
  submitLogin: () => void,
  submitRegister: () => void,
  handleOnClickForgotMyPassword: () => void,
  isRegisterTab: boolean,
};

const Login = ({
  isLoggingIn,
  isRegistering,
  loginErrors,
  registrationErrors,
  submitLogin,
  submitRegister,
  isRegisterTab,
}: Props) => {
  const [showOption, setShowOption] = useState(
    isRegisterTab ? 'register' : 'login',
  );

  return (
    <div className="site-container">
      {showOption === 'register' ? (
        <RegisterBox
          onSubmitRegister={submitRegister}
          isLoading={isRegistering}
          errors={registrationErrors}
          onSwitchToLogin={() => setShowOption('login')}
        />
      ) : (
        <LoginBox
          onSubmitLogin={submitLogin}
          isLoading={isLoggingIn}
          errors={loginErrors}
          onSwitchToRegister={() => setShowOption('register')}
        />
      )}
    </div>
  );
};

export default Login;
